// QR generation for a cellar bottle's own proef link (scanning it with
// this app -- or any camera app -- opens the bottle's detail page
// directly, the "tik het etiket = scan" flow from the design canvas).
import QRCode from "qrcode";

/** The deep link a cellar item's QR code encodes: this app's own origin
 * plus its hash route, so scanning it with any camera app opens proef
 * (installed or not) straight to that bottle. */
export function cellarItemUrl(cellarItemId: string): string {
  return `${window.location.origin}${window.location.pathname}#/cellar/${cellarItemId}`;
}

/** Renders `text` as a QR code onto `canvas`, sized for a small printed
 * label (see LabelPrint.tsx) as well as on-screen display. */
export async function renderQR(canvas: HTMLCanvasElement, text: string, size = 240): Promise<void> {
  await QRCode.toCanvas(canvas, text, {
    width: size,
    margin: 1,
    color: { dark: "#1b0d13", light: "#fdfaf3" },
  });
}
